<!-- Bloc de filtre : parcours → matière (avec « Tous ») + type de test, même
     principe que la banque de questions. Le type est aligné sur la création. -->
<div class="tt-filters">
  <app-searchable-select
    [options]="pathOptions" [value]="selectedPathId"
    [placeholder]="'ADMIN.SELECT_PATH' | translate" icon="fa-solid fa-route"
    [disabled]="isLoadingPaths"
    (valueChange)="onPathChange($event)">
  </app-searchable-select>

  <app-searchable-select
    [options]="subjectOptions" [value]="selectedSubjectId"
    [placeholder]="'ADMIN.SELECT_SUBJECT' | translate" icon="fa-solid fa-book"
    [disabled]="isLoadingPaths"
    (valueChange)="onSubjectChange($event)">
  </app-searchable-select>

  <div class="tt-modes" role="group">
    <button type="button" class="tt-mode" [class.is-active]="!selectedMode"
      (click)="selectedMode = null">{{ 'ADMIN.STATUS_ALL' | translate }}</button>
    <button type="button" class="tt-mode" *ngFor="let m of modes"
      [class.is-active]="selectedMode === m" (click)="onModeChange(m)">
      {{ modeKey(m) | translate }}
    </button>
  </div>
</div>

<ng-container *ngIf="isLoading; else dataGrid">
  <app-loader />
</ng-container>
<ng-template #dataGrid>
  <div class='p-1 p-sm-4 bg-dashboard-card br-9'>
    <div *ngIf="hasError" class="alert alert-danger d-flex align-items-center justify-content-between" role="alert">
      <span><i class="fas fa-triangle-exclamation me-2"></i>{{ errorMessage || ('ERRORS.LOAD_DATA_ERROR' | translate) }}</span>
      <button class="btn btn-sm btn-outline-danger" (click)="retryLoad()">
        {{ 'BUTTONS.RETRY' | translate }}
      </button>
    </div>

    <app-custom-tab *ngIf="!hasError" [data]="filteredTests" [columns]="columns"
      [cellTemplates]="{ testMode: modeTpl, path: pathTpl, startDate: startTpl, endDate: endTpl }"
      [actionTemplate]="actionsTpl" [locale]="currentLocale" [enableRtl]="enableRTL">
    </app-custom-tab>

    <ng-template #modeTpl let-data>{{ modeKey(data.testMode) | translate }}</ng-template>
    <ng-template #pathTpl let-data>{{ pathTitleFor(data.subjectId) }}</ng-template>
    <ng-template #startTpl let-data>{{ data.startDate ? (data.startDate | date: 'yyyy-MM-dd HH:mm') : '—' }}</ng-template>
    <ng-template #endTpl let-data>{{ data.endDate ? (data.endDate | date: 'yyyy-MM-dd HH:mm') : '—' }}</ng-template>

    <ng-template #actionsTpl let-data>
      <button class="btn btn-sm ct-icon-btn" (click)="editTest(data.id)"
        [title]="'BUTTONS.EDIT' | translate">
        <i class="fas fa-edit"></i>
      </button>
      <button class="btn btn-sm ct-icon-btn btn-danger" (click)="onDelete(data)"
        [title]="'BUTTONS.DELETE' | translate">
        <i class="fas fa-trash"></i>
      </button>
      <button class="btn btn-sm ct-icon-btn" (click)="testDetail(data.id)"
        [title]="'BUTTONS.VIEW' | translate">
        <i class="fas fa-eye"></i>
      </button>
      <button class="btn btn-sm mx-1"
        [ngClass]="data.status === 'published' ? 'btn-warning' : 'btn-secondary'"
        (click)="togglePublish(data)"
        [title]="(data.status === 'published' ? 'BUTTONS.UNPUBLISH' : 'BUTTONS.PUBLISH') | translate">
        <i class="fas" [ngClass]="data.status === 'published' ? 'fa-eye-slash' : 'fa-upload'"></i>
      </button>

      <!-- Affecter à un groupe ou à un élève.
           Réservé aux tests publiés : affecter un brouillon donnerait à l'élève
           une copie qui changerait sous lui. C'est aussi par ici que passent les
           groupes issus du classement automatique — ils figurent dans la liste
           du professeur comme les autres. -->
      @if (data.status === 'published') {
        <button class="btn btn-sm ct-icon-btn" (click)="openAssign(data)"
          [title]="'ASSIGNMENTS.ASSIGN' | translate">
          <i class="fas fa-user-plus"></i>
        </button>
      }
    </ng-template>
  </div>
</ng-template>

@if (assignTarget(); as t) {
  <app-assign-test-modal
    [testId]="t.id"
    [testTitle]="t.title"
    [subjectId]="t.subjectId"
    [subjectName]="t.subjectName"
    (closed)="assignTarget.set(null)"
    (created)="assignTarget.set(null)"></app-assign-test-modal>
}
